import { configureWs } from '@ontruck/ontruck-rt-client';
import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import config from 'config';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

/**
 * Remember to memoize the eventHandler with something like useCallback, otherwise
 * the connexion will be stopped and re-started every time that the component using
 * this hook re-renders, even causing multiple connexions at the same time.
 * @param {string} channel
 * @param {string} event
 * @param {function} eventHandler
 * */
export default async function useWebsockets({ channel, event, eventHandler }) {
  const userToken = useSelector((state) => state?.user?.access_token);
  const socket = useRef(null);
  const webSocket = useSelector((store) => getSpecificClientConfig(store, constants.WEB_SOCKET));

  useEffect(() => {
    async function connectToWs() {
      try {
        const newSocket = await configureWs(config.WS_URL, { token: userToken, debug: false })([
          {
            channel: channel,
            callbacks: {
              [event]: eventHandler,
            },
          },
        ]);
        socket.current = newSocket;
      } catch (err) {}
    }

    if (!webSocket || !userToken || !config.WS_URL) {
      return;
    }

    connectToWs();

    return () => {
      if (socket.current) {
        socket.current.disconnect();
      }
    };
    // eslint-disable-next-line
  }, [eventHandler]);
}
